<template>
  <v-dialog v-model="dialog" persistent max-width="520">
    <v-card>
      <v-card-title class="kb-modal-title">
        <h3>{{ title }}</h3>
        <v-btn icon @click="close">
          <v-icon>fal fa-times</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="kb-modal-body">
        <div class="kb-form">
          <div class="kb-field" v-if="mode === 'subcategory'">
            <label>Categoria</label>
            <p class="kb-parent-name">{{ parentCategoryName }}</p>
          </div>

          <div class="kb-field">
            <label>Nome *</label>
            <InputText
              type="text"
              :place-holder="mode === 'category' ? 'Nome da categoria' : 'Nome da subcategoria'"
              v-model="form.name"
              labelCharLimit="200"
              width="100%"
            />
          </div>

          <div class="kb-field">
            <label>Ordem</label>
            <InputText
              type="number"
              v-model="form.orderIndex"
              place-holder="Ordem de exibição (opcional)"
              width="100%"
            />
          </div>

          <div class="kb-field">
            <v-checkbox v-model="form.active" label="Ativa" hide-details />
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="kb-modal-actions">
        <v-btn flat round @click="close">Cancelar</v-btn>
        <v-btn
          flat
          round
          color="white"
          class="btn-primary px-4"
          :disabled="!canSave"
          @click="save"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script type="plain/text">
import FaqService from "@/scripts/services/faq.service";

const emptyForm = () => ({
  id: 0,
  name: "",
  orderIndex: 0,
  active: true,
  categoryId: null
});

export default {
  data: () => ({
    dialog: false,
    mode: "category", // 'category' | 'subcategory'
    parentCategoryName: "",
    form: emptyForm(),
    faqService: new FaqService()
  }),
  computed: {
    isEdit() {
      return this.form.id > 0;
    },
    title() {
      const entity = this.mode === "category" ? "Categoria" : "Subcategoria";
      return `${this.isEdit ? "Editar" : "Nova"} ${entity}`;
    },
    canSave() {
      return !!(this.form.name && this.form.name.trim().length > 0);
    }
  },
  methods: {
    // open('category', categoryItem|null)
    // open('subcategory', subcategoryItem|null, parentCategory)
    open(mode, item, parentCategory) {
      this.mode = mode;
      this.form = emptyForm();

      if (parentCategory) {
        this.form.categoryId = parentCategory.id;
        this.parentCategoryName = parentCategory.name;
      }

      if (item) {
        this.form.id = item.id;
        this.form.name = item.name;
        this.form.orderIndex = item.orderIndex || 0;
        this.form.active = item.active !== false;
        if (item.categoryId) this.form.categoryId = item.categoryId;
      }

      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    save() {
      const payload = {
        id: this.form.id,
        name: this.form.name.trim(),
        orderIndex: Number(this.form.orderIndex) || 0,
        active: this.form.active
      };

      const request =
        this.mode === "category"
          ? this.faqService.saveCategory(payload)
          : this.faqService.saveSubcategory({ ...payload, categoryId: this.form.categoryId });

      request.then(() => {
        this.$emit("saved");
        this.close();
      });
    }
  }
};
</script>

<style scoped>
.kb-modal-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.kb-modal-body {
  padding: 0 !important;
}
.kb-form {
  width: 100%;
  box-sizing: border-box;
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.kb-field {
  display: block;
  width: 100%;
  margin-bottom: 12px;
}
.kb-field > label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #555;
}
.kb-parent-name {
  font-weight: 600;
  color: #333;
  margin: 0;
}
.kb-field /deep/ .input-comp,
.kb-field /deep/ input {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
}
.kb-modal-actions {
  justify-content: flex-end;
  padding: 16px 24px;
}
</style>
